import React from "react";
import "./Pricing.css";
import Topbar from "../../Components/Topbar/Topbar";
import Navbar from "../../Components/Navbar/Navbar";
import GetInTouch from "../Home/Components/GetInTouch/GetInTouch";
import Footer from "../../Components/Footer/Footer";
import Banner2 from "../../Components/Banner/Banner2";
import SimplePricing from "./Components/SimplePricing/SimplePricing";
import OffersPricing from "./Components/OffersPricing/OffersPricing";
const Pricing = () => {
  return (
    <div className="pricing__screen">
      <Topbar />
      <Navbar />
      <Banner2
        heading="Pricing"
        description="Compare your tax summary for free of cost at Serene tax and Get your fastest tax refund possible."
      />
      <SimplePricing />
      <OffersPricing />
      <GetInTouch />
      <Footer />
    </div>
  );
};

export default Pricing;
